var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 32,
    viewBox: "0 0 189 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8457 0C5.77662 0 0.0457153 5.7309 0.0457153 12.8C0.0457153 19.8691 5.77662 25.6 12.8457 25.6C19.9148 25.6 25.6457 19.8691 25.6457 12.8C25.6457 5.7309 19.9148 0 12.8457 0ZM20.2672 14.5361H15.4522C14.9722 14.5361 14.5818 14.9265 14.5818 15.4065V20.2214H11.108V15.4065C11.108 14.9265 10.7177 14.5361 10.2377 14.5361H5.42269V11.0623H10.2377C10.7177 11.0623 11.108 10.672 11.108 10.192V5.37699H14.5818V10.192C14.5818 10.672 14.9707 11.0623 15.4522 11.0623H20.2672V14.5361Z",
    fill: "#6BE4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2391 14.5392H5.42415V11.0654C0.906865 11.0654 0.581833 16.4728 0.581833 16.4728C3.2278 24.7889 11.111 25.4846 11.111 25.4846V15.4096C11.111 14.9296 10.7206 14.5392 10.2407 14.5392H10.2391Z",
    fill: "url(#paint0_linear_28707_16640)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2367 11.0618C10.7167 11.0618 11.107 10.6715 11.107 10.1915V5.37651H14.5808C14.5808 0.85923 9.17345 0.53418 9.17345 0.53418C0.857343 3.18015 0.161682 11.0634 0.161682 11.0634H10.2367V11.0618Z",
    fill: "url(#paint1_linear_28707_16640)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5874 0.115234V5.37527V10.1903C14.5874 10.6702 14.9762 11.0606 15.4577 11.0606H20.2727V14.5344C24.79 14.5344 25.1151 9.12702 25.1151 9.12702C22.4691 0.810905 14.5859 0.115234 14.5859 0.115234H14.5874Z",
    fill: "url(#paint2_linear_28707_16640)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2648 14.5357H15.4498C14.9698 14.5357 14.5794 14.9261 14.5794 15.4061V20.221H11.1057C11.1057 24.7383 16.513 25.0634 16.513 25.0634C24.8291 22.4174 25.5248 14.5342 25.5248 14.5342H20.2648V14.5357Z",
    fill: "url(#paint3_linear_28707_16640)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6457 0H42.6932C49.4971 0 54.72 4.63459 54.72 12.8733C54.72 21.112 49.4971 25.7466 42.6932 25.7466H33.6457V0ZM42.6932 24.0913C48.2109 24.0913 52.6603 20.2667 52.6603 12.8733C52.6603 5.4799 48.2096 1.69184 42.6932 1.6553H35.558V24.0913H42.6932Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3665 15.6323C57.3665 9.01234 61.7429 5.18652 67.1497 5.18652C72.5565 5.18652 76.9329 9.01112 76.9329 15.6323C76.9329 22.2535 72.5565 26.0781 67.1497 26.0781C61.7429 26.0781 57.3665 22.2535 57.3665 15.6323ZM74.984 15.6323C74.984 10.0416 71.5638 6.80528 67.1497 6.76874C62.7356 6.7322 59.3154 10.0416 59.3154 15.6323C59.3154 21.223 62.7356 24.5336 67.1497 24.4971C71.5638 24.4593 74.984 21.223 74.984 15.6323Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6165 15.5958C79.6165 9.45326 83.2572 5.18652 89.3997 5.18652C94.9905 5.18652 98.0428 8.82842 98.485 13.2413H96.5361C96.2791 9.78457 93.7773 6.76752 89.4009 6.76752C84.5459 6.76752 81.5666 10.4094 81.5666 15.5945C81.5666 21.0744 84.9868 24.4959 89.4009 24.4959C93.8151 24.4959 96.1317 21.1487 96.5361 18.4265H98.485C97.9697 22.4362 94.8065 26.0769 89.3997 26.0769C83.552 26.0769 79.6165 21.921 79.6165 15.5945V15.5958Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.537 18.5006C125.537 23.0243 121.713 25.7466 117.004 25.7466H106.485V0H116.563C120.351 0 123.698 2.39099 123.698 6.58343C123.698 9.23142 122.006 11.1803 119.506 11.9902C123.037 12.6528 125.537 14.933 125.537 18.5006ZM108.397 1.6553V11.3289H115.716C119.247 11.3289 121.638 9.56393 121.638 6.58464C121.638 3.60535 119.395 1.6553 116.121 1.6553H108.397ZM123.478 18.5006C123.478 15.0804 120.682 12.9829 116.452 12.9829H108.397V24.0913H116.599C120.535 24.0913 123.478 21.7369 123.478 18.5006Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M147.309 24.2006V25.7451H145.912C144.036 25.7451 142.896 24.605 142.896 22.655V20.3748C141.94 23.9789 138.813 26.1117 135.062 26.1117C131.126 26.1117 128.331 23.8316 128.331 19.9327C128.331 16.3285 130.685 13.8279 135.65 13.8279H138.298C141.498 13.8279 142.674 12.8718 142.674 11.0691C142.674 8.38457 140.467 6.76581 137.231 6.76581C133.773 6.76581 131.345 8.60503 131.015 12.0618H129.103C129.471 7.64766 132.561 5.18359 137.232 5.18359C141.903 5.18359 144.625 7.72196 144.625 11.4735V22.4345C144.625 23.5746 145.104 24.1994 146.17 24.1994H147.31L147.309 24.2006ZM142.785 13.2031H142.748C142.233 14.6367 140.762 15.4467 138.114 15.4467H135.723C131.714 15.4467 130.316 17.7646 130.316 19.9339C130.316 22.2518 131.824 24.4954 135.319 24.4954C138.997 24.4954 142.785 22.0313 142.785 16.3297V13.2031Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M163.936 5.51758L154.005 30.9706C153.748 31.5955 153.158 31.9999 152.35 31.9999H146.06V30.4554H152.312L154.592 24.6442L147.015 5.5188H149.038L155.512 22.548L161.911 5.5188H163.934L163.936 5.51758Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.73 16.6325V5.47461H170.894V10.5594H176.967V5.47461H178.13V16.6325H176.967V11.5796H170.894V16.6325H169.73Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.195 14.3212L188.833 16.6325H187.637L187.111 14.6878C186.522 12.52 185.9 11.8187 184.306 11.8187H181.596V16.6325H180.433V5.47461H184.545C186.936 5.47461 188.482 6.79762 188.482 8.64664C188.482 10.0175 187.59 10.942 186.107 11.3564C187.255 11.8187 187.797 12.8388 188.195 14.3212ZM181.596 6.49476V10.7985H184.37C186.091 10.7985 187.271 10.0493 187.271 8.64664C187.271 7.27581 186.155 6.49476 184.529 6.49476H181.596Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28707_16640",
    x1: 5.84642,
    y1: 11.0654,
    x2: 5.84642,
    y2: 25.4846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28707_16640",
    x1: 14.5808,
    y1: 5.79725,
    x2: 0.161682,
    y2: 5.79725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28707_16640",
    x1: 19.852,
    y1: 14.5344,
    x2: 19.852,
    y2: 0.115234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28707_16640",
    x1: 11.1057,
    y1: 19.8003,
    x2: 25.5248,
    y2: 19.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bda26df08fd1d22610347ec0c9d7f0d8.svg";
export { ForwardRef as ReactComponent };